import { Events as ClientEvents } from '../utils/events'
import events from './raws/events.json'

class Events {
  static initListeners() {
    Events.handleEvent('keep_worker_alive', () => {})
    Events.handleEvent('request:pingWorker', ({ responseId }) => {
      Events.dispatchEvent(responseId, { received: true })
    })
  }
  static dispatchEvent(eventName, data = {}) {
    try {
      if (window.autoIncrementId) ClientEvents.dispatchEvent(eventName, data)
      return
    } catch (error) {}

    if (!events[eventName] && !/^(request)|(response):.+/.test(eventName)) {
      console.error(`Event ${eventName} is not registered in events list`)
      return
    }
    // if (!data?.hide_log) console.log(`dispatch Event ${eventName}`)
    self.clients.matchAll().then(clients => {
      clients.forEach(client =>
        client.postMessage({
          name: eventName,
          data,
        }),
      )
    })
    self.dispatchEvent(
      new CustomEvent(eventName, {
        detail: data,
      }),
    )
  }

  static handleEvent(eventName, callback) {
    try {
      if (window.autoIncrementId) ClientEvents.handleEvent(eventName, callback)
      return
    } catch (error) {}
    if (!events[eventName] && !/^(request)|(response):.+/.test(eventName)) {
      console.error(`Event ${eventName} is not registered in events list`)
      return
    }
    self.addEventListener(eventName, event => {
      callback(event.detail)
    })
    self.addEventListener('message', event => {
      if (!event.data.name || event.data.name !== eventName) return
      callback(event.data.data)
    })
  }

  static sendDataRequest(dataName, onResponse, data) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return {}
    const eventName = `request:${dataName}`
    const responseId = `response:${dataName}:${window.autoIncrementId++}`
    Events.handleEvent(responseId, responseData => {
      Events.removeHandler(eventId)
      onResponse(responseData)
    })
    const eventId = Events.dispatchEvent(eventName, { ...data, responseId })
    return {
      responseId,
      unsubscribe: () => {
        Events.removeHandler(eventId)
      },
    }
  }

  static async sendDataRequestResolve(dataName, data, timeout = 30000) {
    const response = await new Promise(resolve => {
      Events.sendDataRequest(dataName, resolve, data)
      setTimeout(resolve, timeout, null)
    })
    return response
  }

  static removeHandler(id) {
    try {
      if (window.autoIncrementId) ClientEvents.removeHandler(id)
      return
    } catch (error) {}
  }
}

export { Events }
